import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints, fontWeights,
}: Theme) => ({
  paper: {
    '&&': {
      width: '95vw',
      maxWidth: '100%',
      borderRadius: '0.5rem',
      paddingTop: '2rem',
      paddingBottom: '2rem',
      [breakpoints.up('md')]: {
        width: '34.875rem',
        paddingTop: '3rem',
        paddingBottom: '3rem',
      },
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    '&&': {
      paddingLeft: '1rem',
      paddingRight: '1rem',
      [breakpoints.up('md')]: {
        paddingLeft: '3rem',
        paddingRight: '3rem',
      },
    },
  },
  title: {
    fontWeight: fontWeights.medium,
    '&&': {
      [breakpoints.up('md')]: {
        fontSize: '1.75rem',
        lineHeight: 1.3,
      },
    },
  },
  button: {
    [breakpoints.up('md')]: {
      marginTop: '0.5rem',
    },
  },
}));
